import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { App } from './App';
import { DevModeBanner } from './components/DevModeBanner';
import './styles/global.css';

// Clerk publishable key
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '';

const isClerkConfigured = Boolean(CLERK_PUBLISHABLE_KEY);

if (!isClerkConfigured) {
  console.warn(
    'VITE_CLERK_PUBLISHABLE_KEY is not set. Running in development mode without authentication. ' +
    'Set the environment variable or configure it in your .env file to enable authentication.'
  );
}

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

// Wrapper component that conditionally uses ClerkProvider
function RootApp() {
  const appElement = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );

  return (
    <>
      {!isClerkConfigured && <DevModeBanner />}
      {isClerkConfigured ? (
        <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
          {appElement}
        </ClerkProvider>
      ) : (
        appElement
      )}
    </>
  );
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
